import { defineRecipe } from "@chakra-ui/react"

export const buttonRecipe = defineRecipe({
  variants: {
    variant: {
      solid: {
        bg: "primary",
        _hover: {
          bg: "#4f1629",
        },
        _expanded: {
          bg: "#4f1629",
        },
      },
    }
  }
})
